module.exports = __webpack_public_path__ + "img/science.c59502a8.svg";